// TB-110: consultation fees and earnings are stored in BHD.
// TB-122: shown in the admin's display currency (BHD 12.000 or $31.91).
// Subscription plans carry their own currency (TB-105, utils/planPrice.js).
import { formatDisplay } from '@/utils/invoiceTotals'

export function formatFee (bhd) {
  return formatDisplay(bhd)
}

export default formatFee
